module.exports = __webpack_public_path__ + "img/arrow-v.45b71b6d.svg";